import React from "react";
import { isJSON } from "../../../utils/isJson";

export const DbAnalyzerReportArea = ({ report }) => {
  if (!report || !report.json) return null;
  const htmlContent = { __html: report.json };
  return <div dangerouslySetInnerHTML={htmlContent}></div>;
};



// WEBPACK FOOTER //
// ./src/components/diagnostics/dbAnalysisModule/ReportArea.jsx